// extracted by mini-css-extract-plugin
module.exports = {"modal":"menu-module--modal--qbCRF"};